import apiCall from "./apiCall";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  async fetchAccount(data) {
    let response = await apiCall("account/list", data);
    return response;
  },

  async CreateCallStation(data) {
    let response = await apiCall("station/add", data);
    return response;
  },
  async callStation_count(school) {
    let data = {
      school_id: school
    };
    let response = await apiCall("station/count", data);
    return response;
  },
  async countAllStations(data) {
    let response = await apiCall("station/count", data);
    return response;
  },
  async countActiveStations() {
    let data = {
      status: "300"
    };
    let response = await apiCall("station/count", data);
    return response;
  },
  async countInactiveStations() {
    let data = {
      status: "500"
    };
    let response = await apiCall("station/count", data);
    return response;
  },
  async countOffStations() {
    let data = {
      status: "000"
    };
    let response = await apiCall("station/count", data);
    return response;
  },
  async updateAccount(data) {
    let response = await apiCall("account/update", data);
    return response;
  },
  async listZegoCallLogs(page) {
    let data = {
      page: page,
      provider: "BUZZ",
      call_type: "voice"
    };
    let response = await apiCall("call_log/list", data);
    return response;
  },

  async listBuzzVideoCallLogs(page) {
    let data = {
      page: page,
      provider: "BUZZ",
      call_type: "video"
    };
    let response = await apiCall("call_log/list", data);
    return response;
  },
  
  async listTwilioCallLogs(page) {
    let data = {
      page: page,
      provider: "GSM"
    };
    let response = await apiCall("call_log/list", data);
    return response;
  },
  async listSchoolTwilioCallLogs(page, school) {
    let data = {
      school_id: school,
      page: page,
      provider: "GSM"
    };
    let response = await apiCall("call_log/list", data);
    return response;
  },
  async listSchoolZegoCallLogs(page, school) {
    let data = {
      school_id: school,
      page: page,
      provider: "BUZZ"
    };
    let response = await apiCall("call_log/list", data);
    return response;
  },
  async countLogsToday(data) {
    let response = await apiCall("call_log/count/today", data);
    return response;
  },
  async countSchoolLogsToday(school) {
    let data = {
      school_id: school
    };
    let response = await apiCall("call_log/count/today", data);
    return response;
  },
  async countBuzzVoiceCallsToday() {
    let data = {
      call_type: "voice",
      provider: "BUZZ"
    };
    let response = await apiCall("call_log/count/today", data);
    return response;
  },
  async countCompletedBuzzVoiceCallsToday() {
    let data = {
      call_type: "voice",
      provider: "BUZZ",
      status: "completed"
    };
    let response = await apiCall("call_log/count/today", data);
    return response;
  },
  async countMissedBuzzVoiceCallsToday() {
    let data = {
      call_type: "voice",
      provider: "BUZZ",
      status: "missed"
    };
    let response = await apiCall("call_log/count/today", data);
    return response;
  },
  async countSchoolBuzzVoiceCallsToday(school) {
    let data = {
      call_type: "voice",
      provider: "BUZZ",
      school_id: school
    };
    let response = await apiCall("call_log/count/today", data);
    return response;
  },
  async countBuzzVideoCallsToday() {
    let data = {
      call_type: "video",
      provider: "BUZZ"
    };
    let response = await apiCall("call_log/count/today", data);
    return response;
  },

  async countBuzzVideoCallsOverall(data) {
    let response = await apiCall("call_number/category/total", data);
    return response;
  },
  async countCompletedBuzzVideoCallsToday() {
    let data = {
      call_type: "video",
      provider: "BUZZ",
      status: "completed"
    };
    let response = await apiCall("call_log/count/today", data);
    return response;
  },
  async countCompletedCallsPerCategory() {
    let data = {
      status: "completed"
    };
    let response = await apiCall("call_number/category/total", data);
    return response;
  },
  async countMissedCallsPerCategoryOverall() {
    let data = {
      status: "missed"
    };
    let response = await apiCall("call_number/category/total", data);
    return response;
  },
  async countMissedBuzzVideoCallsToday() {
    let data = {
      call_type: "video",
      provider: "BUZZ",
      status: "missed"
    };
    let response = await apiCall("call_log/count/today", data);
    return response;
  },
  async countSchoolBuzzVideoCallsToday(school) {
    let data = {
      call_type: "video",
      provider: "BUZZ",
      school_id: school
    };
    let response = await apiCall("call_log/count/today", data);
    return response;
  },
  async countGSMCallsToday() {
    let data = {
      provider: "GSM"
    };
    let response = await apiCall("call_log/count/today", data);
    return response;
  },
  async countCompletedGSMCallsToday() {
    let data = {
      provider: "GSM",
      status: "completed"
    };
    let response = await apiCall("call_log/count/today", data);
    return response;
  },
  async countMissedGSMCallsToday() {
    let data = {
      provider: "GSM",
      status: "missed"
    };
    let response = await apiCall("call_log/count/today", data);
    return response;
  },
  async countSchoolGSMCallsToday(school) {
    let data = {
      provider: "GSM",
      school_id: school
    };
    let response = await apiCall("call_log/count/today", data);
    return response;
  },
  async countCompletedCallsToday() {
    let data = {
      status: "completed"
    };
    let response = await apiCall("call_log/count/today", data);
    return response;
  },
  async countSchoolCompletedCallsToday(school) {
    let data = {
      status: "completed",
      school_id: school
    };
    let response = await apiCall("call_log/count/today", data);
    return response;
  },
  async countMissedCallsToday() {
    let data = {
      status: "missed"
    };
    let response = await apiCall("call_log/count/today", data);
    return response;
  },
  async countSchoolMissedCallsToday(school) {
    let data = {
      status: "missed",
      school_id: school
    };
    let response = await apiCall("call_log/count/today", data);
    return response;
  },
  async countWeeklyCalls(data) {
    let response = await apiCall("call_log/weekly", data);
    return response;
  },
  async countLogsPerCategory(data) {
    let response = await apiCall("call_number/category/total", data);
    return response;
  },
  async callCostPerCategoryOverall(data) {
    let response = await apiCall("call_cost/category/overall", data);
    return response;
  },
  async callCostPerCategoryToday(data) {
    let response = await apiCall("call_cost/category/today", data);
    return response;
  },
  async countSchoolLogsPerCategory(school) {
    let data = {
      school_id: school
    };
    let response = await apiCall("call_number/category/total", data);
    return response;
  },
  async countStudentLogs(student) {
    let data = {
      caller_id: student,
      status: "completed"
    };
    let response = await apiCall("call_log/count", data);
    return response;
  },
  async countCompletedLogs() {
    let data = {
      status: "completed"
    };
    let response = await apiCall("call_log/count", data);
    return response;
  },
  async countMissedLogs() {
    let data = {
      status: "missed"
    };
    let response = await apiCall("call_log/count", data);
    return response;
  },
  async countSchoolCompletedLogs(school) {
    let data = {
      status: "completed",
      school_id: school
    };
    let response = await apiCall("call_log/count", data);
    return response;
  },
  async countSchoolMissedLogs(school) {
    let data = {
      status: "missed",
      school_id: school
    };
    let response = await apiCall("call_log/count", data);
    return response;
  },
  async searchTwilioLogs(page,searchStudent,school,startDate,endDate) {
    let data = {
      provider: "GSM",
      page: page,
      search_caller: searchStudent,
      school_id: school,
      from: startDate,
      to: endDate,
    };
    let response = await apiCall("call_log/list", data);
    return response;
  },
  async searchSchoolTwilioLogs(page,searchStudent,startDate,endDate,school) {
    let data = {
      provider: "GSM",
      page: page,
      search_caller: searchStudent,
      from: startDate,
      to: endDate,
      school_id: school
    };
    let response = await apiCall("call_log/list", data);
    return response;
  },
  async searchZegoLogs(page,searchStudent,school,startDate,endDate) {
    let data = {
      provider: "BUZZ",
      page: page,
      search_caller: searchStudent,
      school_id: school,
      from: startDate,
      to: endDate,
      call_type: "voice"
    };
    let response = await apiCall("call_log/list", data);
    return response;
  },
  async searchBuzzVideoLogs(page,searchStudent,school,startDate,endDate) {
    let data = {
      provider: "BUZZ",
      page: page,
      search_caller: searchStudent,
      school_id: school,
      from: startDate,
      to: endDate,
      call_type: "video"
    };
    let response = await apiCall("call_log/list", data);
    return response;
  },
  async searchSchoolZegoLogs(page,searchStudent, startDate,endDate,school) {
    let data = {
      provider: "BUZZ",
      page: page,
      search_caller: searchStudent,
      from: startDate,
      to: endDate,
      school_id: school
    };
    let response = await apiCall("call_log/list", data);
    return response;
  },
  async listStudentCallLogs(page, caller_id) {
    let data = {
      page: page,
      caller_id: caller_id
    };
    let response = await apiCall("call_log/list", data);
    return response;
  },
  async listRecentCallLogs(school_id) {
    let data = {
      school_id: school_id
    };
    let response = await apiCall("call_log/recent", data);
    return response;
  },
  async searchSchoolTypeLogs(school_id,provider,page,searchStudent,searchContact,startDate,endDate) {
    let data = {
      school_id:school_id,
      provider: provider,
      page: page,
      search_caller: searchStudent,
      search_callee: searchContact,
      from: startDate,
      to: endDate,
    };
    let response = await apiCall("call_log/list", data);
    return response;
  },
  async listUserCallLogs(user_id) {
    let data = {
      user_id: user_id
    };
    let response = await apiCall("call_log/list/user", data);
    return response;
  },

  async callCostEachMonth(data) {
    let response = await apiCall("call_cost/each_month/report", data);
    return response;
  },

  async callCategoriesCostEachMonth(data) {
    let response = await apiCall("call_cost/category/each_month/report", data);
    return response;
  },

  async callsSumForSchool(school_id) {
    let data = {
      school_id: school_id
    };
    let response = await apiCall("call_number/category/each_month/school", data);
    return response;
  },

  async callsSum(data) {
    let response = await apiCall("call_number/category/each_month/school", data);
    return response;
  },

  async averageCallDuration(data) {
    let response = await apiCall("call_duration/average/overall", data);
    return response;
  },

  async averageCallDurationToday(data) {
    let response = await apiCall("call_duration/average/today", data);
    return response;
  },

  async longestCallDuration(data) {
    let response = await apiCall("call_duration/longest", data);
    return response;
  },

  async averageSchoolCallDuration(school) {
    let data ={
      school_id: school
    }
    let response = await apiCall("call_duration/average/overall", data);
    return response;
  },

  async averageSchoolCallDurationToday(school) {
    let data ={
      school_id: school
    }
    let response = await apiCall("call_duration/average/today", data);
    return response;
  },

  async longestSchoolCallDuration(school) {
    let data ={
      school_id: school
    }
    let response = await apiCall("call_duration/longest", data);
    return response;
  },

  async averageBuzzChatSize(data) {
    let response = await apiCall("chat/average_length", data);
    return response;
  },

  async buzzMessagesPerCategory(data) {
    let response = await apiCall("chat/category/count", data);
    return response;
  },

  async averageGSMSize(data) {
    let response = await apiCall("gsm/average_length", data);
    return response;
  },

  async countGSMMessages(data) {
    let response = await apiCall("gsm/count", data);
    return response;
  },

  async countGSMMessagesToday(data) {
    let response = await apiCall("gsm/count/today", data);
    return response;
  },

  async buzzMessagesPerCategoryToday(data) {
    let response = await apiCall("chat/category/count/today", data);
    return response;
  },
  
  async messageCostPerCategoryToday(data) {
    let response = await apiCall("chat/category/cost/today", data);
    return response;
  },
  async messageStatisticsToday(data) {
    let response = await apiCall("message/stats/today", data);
    return response;
  },
  async messageStatisticsOverall(data) {
    let response = await apiCall("message/stats/overall", data);
    return response;
  },
  async filterMessageStatisticsOverall(from, to, school_id) {
    let data ={
      from: from,
      to:to,
      school_id:school_id
    }
    let response = await apiCall("message/stats/overall", data);
    return response;
  },
  async filterCallStatisticsOverall(from, to, school_id) {
    let data ={
      from: from,
      to:to,
      school_id:school_id
    }
    let response = await apiCall("call/stats/overall", data);
    return response;
  },
  async callStatisticsToday(data) {
    let response = await apiCall("call/stats/today", data);
    return response;
  },
  async schoolCallStatisticsToday(school_id) {
    let data ={
      school_id:school_id
    }
    let response = await apiCall("call/stats/today", data);
    return response;
  },
  async callStatisticsOverall(data) {
    let response = await apiCall("call/stats/overall", data);
    return response;
  },
  async schoolCallStatisticsOverall(school_id) {
    let data ={
      school_id:school_id
    }
    let response = await apiCall("call/stats/overall", data);
    return response;
  },

  async callHighlights(data) {
    let response = await apiCall("call_log/get_highlights", data);
    return response;
  },

  async messageHighlights(data) {
    let response = await apiCall("message/highlights", data);
    return response;
  },

  async fetchGlobalCommunicationSettings() {
    let data = {
      type: "global"
    };
    let response = await apiCall("communication/setting/list", data);
    return response;
  },

  async fetchSchoolCommunicationSettings() {
    let data = {
      type: "school"
    };
    let response = await apiCall("communication/setting/list", data);
    return response;
  },

  async fetchStationCommunicationSettings() {
    let data = {
      type: "station"
    };
    let response = await apiCall("communication/setting/list", data);
    return response;
  },

  async createSetting(function_name, school_id, station_id) {
    let data = {
      function_name: function_name,
      school_id: school_id,
      station_id:station_id
    };
    let response = await apiCall("communication/setting/add", data);
    return response;
  },
async enableCommunication(id) {
    let data = {
      id: id
    };
    let response = await apiCall("communication/setting/enable", data);
    return response;
  },
  async disableCommunication(id) {
    let data = {
      id: id
    };
    let response = await apiCall("communication/setting/disable", data);
    return response;
  },
  async getTwilioBalance(data) {
    let response = await apiCall("call_credit/balance", data);
    return response;
  },
};
